import { CometUserRoleType } from '@zg-rentals/rental-manager-env';
import type { TabbedPageConfigItem } from './TabbedPage.config';
import { TabbedPageEnum } from './TabbedPage.config';
import { type RentalManagerAuthCheckUserInfoWebApiDto } from '@zg-rentals/ts-rental-manager-api-client';
import Cookies from 'js-cookie';

export const isTabActive = (
  config: TabbedPageConfigItem,
  user: RentalManagerAuthCheckUserInfoWebApiDto | null,
  isEliseSfhEnabled = false,
) => {
  if (!user) return false;
  const isImpersonator = Boolean(user?.impersonatorEmail);
  const isNonAdvertiser = user.roleTypes.some((role) => role === CometUserRoleType.NON_ADVERTISER_CUSTOMER);

  if (config.featureFlag) {
    return Cookies.get(config.featureFlag as unknown as string) === 'true';
  }

  if (config.allowOnlyForImpersonators) {
    return isImpersonator;
  }

  if (config.blockForNonAdvertisers && isNonAdvertiser) {
    return false;
  }

  if (config.allowOnlyForMultifamilyCustomers && !user.isMultifamilyCustomer) {
    return config.page === TabbedPageEnum.EliseDataSharing ? Boolean(isEliseSfhEnabled) : false;
  }

  return true;
};

const customerZrnRegex = /[a-zA-Z]{3}-[0-9]*/;

export const zrnNumberFormat = (customerZrn: string) => {
  if (customerZrnRegex.test(customerZrn)) {
    return customerZrn;
  }

  return `ZRN-${customerZrn}`;
};
